import axios from "axios";
import { Url } from './config'


export const setToken = () => {
  const auth = JSON.parse(localStorage.getItem("login"));
  const token = auth.token;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};


export const Instance = axios.create({
  baseURL: Url,
});
